import {Component} from "@angular/core";
import {NavController} from "ionic-angular";
import {FormGroup, Validators, FormBuilder} from "@angular/forms";
import {JobsPage} from "../jobs/jobs.page";
import {SignupPage} from "../signup/signup.page";
import {PushService} from "../../app/core/push.service";
import {environment} from "../../app/config/environment";
import {AppAuth} from "../../app/core/auth";
import {RoleService} from "../../app/core/role.service";

@Component({
  templateUrl: 'login.page.html'
})
export class LoginPage {
  form: FormGroup;
  user = {email: '', password: ''};
  private userControlsConfig = {
    email: ['', Validators.required],
    password: ['', Validators.required]
  };
  clientUrl: string;

  constructor(fb: FormBuilder,
              private auth: AppAuth,
              private nav: NavController,
              private pushService: PushService,
              private roleService: RoleService
  ) {
    this.form = fb.group(this.userControlsConfig);
    this.clientUrl = environment.clientUrl;
  }

  goToSignupPage(){
    this.nav.push(SignupPage);
  }


  login() {
    this.auth.login(this.user)
      .subscribe(success => {
        // If role not set, set role based on user details
        this.roleService.setRole(success.user.organisation_id ? 'organisation' : 'interpreter')
          .then(() => this.nav.setPages([{page: JobsPage}]));
        this.pushService.registerDeviceForUser();
      });
  }

}




// WEBPACK FOOTER //
// ./src/pages/login/login.page.ts